import ProductAlternativeSkeleton from './ProductAlternativeSkeleton.vue'

export default ProductAlternativeSkeleton
